import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setTextures: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.total = payload.total;
  state.list.loading = !!payload.loading;
};

// 子列表
export const queryPakFiles: Mutation<IModuleState> = (state, payload) => {
  state.sublist.data = payload.data;
  state.sublist.loading = !!payload.loading;
};

// 日志
export const setTextureLogs: Mutation<IModuleState> = (state, payload) => {
  state.logs.data = payload.data;
  state.logs.loading = !!payload.loading;
};

// 贴图包类型
export const setTextureTypes: Mutation<IModuleState> = (state, payload) => {
  state.types.data = payload.data;
  state.types.raw = payload.data;
  state.types.loading = !!payload.loading;
};

// launcher 下载列表
export const setDownloadList: Mutation<IModuleState> = (state, payload) => {
  state.downloads.data = payload.data;
  state.downloads.loading = !!payload.loading;
};

// 弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
  state.dialog.type = payload.type;
  state.dialog.data = payload.data;
};

// confirm 弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
  state.confirm.name = payload.name;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = payload;
};
